/**
 * ============================================================================
 * FIRE SAFETY SCANNER - CONFIGURATION CONSTANTS
 * ============================================================================
 * All static configuration objects extracted from App.js
 * Version: v3.10.0-CLEAR-MAP
 * 
 * This file contains:
 * - Attribution system configuration
 * - OAuth provider configuration (Google, Microsoft)
 * - Vapi.ai configuration (commented out - not ready)
 * - Backend URL configuration
 */

// ============================================================================
// ATTRIBUTION SYSTEM CONFIGURATION
// ============================================================================
export const ATTRIBUTION_CONFIG = {
  enabled: false, // Set to false to disable attribution entirely
  required: false, // Set to true to make attribution mandatory (DEMO: triggers on first submission)
  allowSkip: true, // Allow users to skip attribution
  providers: {
    google: false, // Enable Google OAuth
    microsoft: false, // Enable Microsoft OAuth
    email: true // Enable email/password signup
  }
};

// ============================================================================
// OAUTH CONFIGURATION (for localhost development)
// ============================================================================
export const OAUTH_CONFIG = {
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || 'demo-google-client-id',
    redirectUri: `${window.location.origin}`,
    scopes: 'openid profile email'
  },
  microsoft: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID || 'demo-microsoft-client-id',
    redirectUri: `${window.location.origin}/auth/microsoft/callback`,
    tenantId: process.env.REACT_APP_MS_TENANT_ID || 'common'
  }
};

// ============================================================================
// VAPI.AI VOICE AGENT CONFIGURATION
// ============================================================================
// BLOCKED OUT - Vapi.ai Voice Agent Configuration (Not ready for premiere)
export const VAPI_CONFIG = {
  enabled: false,
  publicKey: 'e73916ba-515a-4a6e-85ff-dc208385eb9e',
  assistantId: '1ec0bb05-5e47-4f1d-9857-03e1c5d793ec'
};

// ============================================================================
// BACKEND URL CONFIGURATION
// ============================================================================
// For web app: Use empty string to make relative API calls to same domain
// For mobile app: Must specify full backend URL
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// ============================================================================
// APP VERSION
// ============================================================================
export const APP_VERSION = 'v75-android-network-fix';

// ============================================================================
// PAGINATION DEFAULTS
// ============================================================================
export const PAGINATION_DEFAULTS = {
  leaderboardPageSize: 3,
  dataTablePageSize: 20
};

// ============================================================================
// ROLE DISPLAY MAPPING — Single source of truth for hierarchy labels
// Internal DB values → User-facing display names
// ============================================================================
export const ROLE_LABELS = {
  regional_sales_leader: { full: 'Regional Vice President', short: 'RVP', badge: 'RVP' },
  area_sales_manager:    { full: 'Regional Director',       short: 'RD',  badge: 'RD' },
  asm:                   { full: 'Area Sales Manager',      short: 'ASM', badge: 'ASM' },
};

export const getRoleLabel = (roleValue, format = 'full') => {
  const entry = ROLE_LABELS[roleValue || 'regional_sales_leader'];
  if (!entry) return roleValue || 'Unknown Role';
  return entry[format] || entry.full;
};

export const ROLE_OPTIONS = [
  { value: 'regional_sales_leader', label: ROLE_LABELS.regional_sales_leader.full },
  { value: 'area_sales_manager',    label: ROLE_LABELS.area_sales_manager.full },
  { value: 'asm',                   label: ROLE_LABELS.asm.full },
];

